// @flow

import onBeforeUnloadHandler from 'window-onbeforeunload-handler';
import ko from 'rgs-knockout';
import _ from 'lodash';
import window from 'window';

import { scrollTo } from 'app/v2/utils';
import { menuTypes, MENU_ITEMS_KEYS } from './types';
import SmartMenu from './components/menu';
import { MenuJSable, MenuItem } from './helpers/menu-jsable';

import { default as browserDetector } from 'browser-type-detector';

import type { ObservableArray, PureComputed, Observable } from 'rgs-knockout';
import type { IMenuConfiguration } from '../types.flow.js';

type MenuOptions = {
	onGetUrlDependencies: () => ObservableArray<*>;
	onItemsFetch: () => Promise<*>;
	onLogout: () => Promise<any>;
	cfg: IMenuConfiguration;
}

export interface IMenuModel {
	setState(): void;
	requestItems(): void;
}

// TODO: REMAKE IT!

export class MenuModel implements IMenuModel {
	onGetUrlDependencies: () => ObservableArray<*>;
	isPwaMode: boolean;
	props: {
		smartMenu: {
			checker: PureComputed<boolean>
		},
		items: ObservableArray<MenuItem>
	};

	_cfg: Observable<IMenuConfiguration>;
	_tasks: *[];
	_options: MenuOptions;

	_isListRendered: Observable<boolean> = ko.observable(false).extend({notify: 'always'});
	_isFetching: Observable<boolean> = ko.observable(false);
	_smartMenu = new SmartMenu().props; //mobile menu
	static _menuJSable = new MenuJSable();


	get cfg (): IMenuConfiguration {
		return ko.unwrap(this._cfg);
	}

	constructor (options: MenuOptions) {
		const {
			onGetUrlDependencies,
			onLogout,
			cfg,
		} = options || {};

		this._options = options;

		this._cfg = ko.observable(cfg);
		this._tasks = [];

		this.onGetUrlDependencies = onGetUrlDependencies;

		this.items = ko.pureComputed(this._mapToRgsMenuModel);

		this.isPwaMode = browserDetector.isStandalonePwa();

		this.props = {
			configuration: this._cfg,
			onLogoutClick: onLogout,
			smartMenu: this._smartMenu,

			isListRendered: this._isListRendered,
			onListRendered: this._sayScreenAdapterAboutChanges,
			onLinkClick: this._handleLinkClick,

			items: this.items,
			activeItem: ko.observable(),
			dmsTabBarItems: ko.pureComputed(() => this._createDmsTabBarItems()),
			dmsTabBarMore: ko.observable(false),
			dmsTabBarMoreItems: ko.computed(() => {
				const allMenuItems = this.items();
				const dmsInsuredMenuItem = allMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_DEFAULT);

				if (_.isEmpty(dmsInsuredMenuItem)) {
					return [];
				}

				const dmsInsuredMenuItems = dmsInsuredMenuItem.Items;

				const dmsMedTypes = dmsInsuredMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_MEDICAL_TYPES);
				if (dmsMedTypes) {
					dmsMedTypes.TabTitle = 'Виды помощи';
					// dmsMedTypes.Icon.attributes.class = this._getNfdIconClasses('med-types');
					dmsMedTypes.TabIcon = {
						attributes: {
							class: this._getNfdIconClasses('med-types'),
						},
					};
				}

				const dmsPrograms = dmsInsuredMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_INSURANCE_PROGRAMS);
				if (dmsPrograms) {
					dmsPrograms.TabTitle = 'Программа';
					dmsPrograms.TabIcon = {
						attributes: {
							class: this._getNfdIconClasses('insurance-program'),
						},
					};
				}
	
				const dmsFranchise = dmsInsuredMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_FRANCHISE);

				if (dmsFranchise) {
					dmsFranchise.TabTitle = 'Франшиза';
					dmsFranchise.TabIcon = {
						attributes: {
							class: this._getNfdIconClasses('franshise'),
						},
					};
				}

				const dmsFamilyInsurance = dmsInsuredMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_FAMILY_INSURANCE);

				if (dmsFamilyInsurance) {
					dmsFamilyInsurance.TabTitle = 'Страхование родственников';
					dmsFamilyInsurance.TabIcon = {
						attributes: {
							class: this._getNfdIconClasses('family-insurance'),
						},
					};
				}

				const dmsUpgradeProgram = dmsInsuredMenuItems
					.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_UPGRADE_PROGRAM);

				if (dmsUpgradeProgram) {
					dmsUpgradeProgram.TabTitle = 'Улучшить программу';
					dmsUpgradeProgram.TabIcon = {
						attributes: {
							class: this._getNfdIconClasses('program-upgrade'),
						},
					};
				}

				const changePassword = {
					TabTitle: ko.observable('Пароль и вход по FaceID/TouchID'),
					Key: 'changePassword',
					Url: '/private/profile.wbp#/password',
					Attributes: {},
					TabIcon: {
						attributes: {
							class: this._getNfdIconClasses('profile'),
						},
					},
					Items: [],
					Active: this.props && this.props.activeItem(), //to fix error when go to Profile page
				};

				const userProfile = {
					TabTitle: ko.observable('Персональные данные'),
					Key: 'userProfile',
					Url: '/private/profile.wbp?insurer#/insurer',
					Attributes: {},
					TabIcon: {
						attributes: {
							class: this._getNfdIconClasses('profile'),
						},
					},
					Items: [],
					Active: this.props && this.props.activeItem(), //to fix error when go to Profile page
				};

				return _.compact([
					dmsMedTypes,
					dmsPrograms,
					dmsFranchise,
					dmsFamilyInsurance,
					dmsUpgradeProgram,
					changePassword,
					userProfile,
				]);
			}),
		};
	}

	_createDmsTabBarItems = () => {
		const allMenuItems = this.items();
		const dmsInsuredMenuItem = allMenuItems
			.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_DEFAULT);

		if (_.isEmpty(dmsInsuredMenuItem)) {
			return [];
		}

		const dmsInsuredMenuItems = dmsInsuredMenuItem.Items;

		const dmsMedCare = dmsInsuredMenuItems
			.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_MEDICAL_CARE);
		if (dmsMedCare) {
			dmsMedCare.TabTitle = 'Цифр. клиника';
			dmsMedCare.Icon.attributes.className = this._getNfdIconClasses('medcare');
		}
		
		const dmsPolicy = dmsInsuredMenuItems
			.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_POLICY);
		if (dmsPolicy) {
			dmsPolicy.TabTitle = 'Полис';
			dmsPolicy.Icon.attributes.className = this._getNfdIconClasses('policy');
		}

		const dmsRequest = dmsInsuredMenuItems
			.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_SEND_REQUEST);
		if (dmsRequest) {
			dmsRequest.TabTitle = 'Заявки';
			dmsRequest.Icon.attributes.className = this._getNfdIconClasses('request');
		}

		const dmsLpu = dmsInsuredMenuItems
			.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_LPU);
		if (dmsLpu) {
			dmsLpu.TabTitle = 'Клиники';
			dmsLpu.Icon.attributes.className = this._getNfdIconClasses('lpu');
		}

		// const dmsMedCare = dmsInsuredMenuItems
		// 	.find(i => i.Key() === MENU_ITEMS_KEYS.DMS.DMS_MEDICAL_TYPES);
		// if (dmsMedCare) {
		// 	dmsMedCare.TabTitle = 'Виды помощи';
		// 	dmsMedCare.Icon.attributes.className = this._getNfdIconClasses('medcare');
		// }

		const more = {
			TabTitle: ko.observable('Ещё'),
			Key: 'more',
			Url: ko.observable(''),
			Attributes: {},
			Icon: {
				attributes: {
					className: this._getNfdIconClasses('more'),
				},
			},
			Items: [],
			Active: this.props.activeItem(),
		};

		const items = _.compact([
			dmsMedCare,
			dmsPolicy,
			dmsRequest,
			dmsLpu,
			more,
		]);

		for (const i in items) {
			const menuItem = items[i];
			menuItem.IsActive = this._isActiveItem(menuItem);
		}

		if (window.location.hash && !items.some(menuItem => menuItem.IsActive)) {
			_.last(items).IsActive = true;
		}

		return items;
	}

	_isActiveItem (menuItem): Boolean {
		const moreIsOpened = ko.unwrap(this.props.dmsTabBarMore);
		const location = this._getCurrentLocation();

		const isActive = (moreIsOpened && menuItem.Key === 'more')
			|| (!moreIsOpened && location.includes(menuItem.Attributes.href));

		return isActive;
	}

	_getCurrentLocation (): string {
		const path = window.location.pathname;
		const hash = window.location.hash;

		return `${path}${hash}`;
	}

	_getNfdIconClasses (iconName: string) {
		return `nfd-icon nfd-text-middle nfd-icon-${iconName}`;
	}
	
	_mapToRgsMenuModel = (): MenuItem[] => {
		const items = ko.unwrap(MenuModel._menuJSable.Items);
		const urls = this.onGetUrlDependencies(); // tracked;

		const mapper = MenuJSable.use(this.cfg);

		return (items || []).map(item => {
			const {Items, ...rest} = mapper(urls, item);
			const items = Items.map((subItem: MenuItem) => mapper(urls, subItem));
			// const mappedItems = items.map((subItem) => {
			//
			// 	return {
			// 		...subItem,
			// 		Items: subItem.Items.map((subsubItem) => mapper(urls, subsubItem)),
			// 	};
			// });
			// console.log(mappedItems);

			return {
				...rest,
				Items: items,
			};
		});
	};


	//why to handle click by link with JS?
	//because bootstrap-dropdown kill all events propagation, we don't have a chance, probably
	_handleLinkClick = (item: MenuItem) => {
		const menuKey = ko.unwrap(item.Key);
		const isMoreItem = menuKey === 'more';
		if (isMoreItem) {
			this.props.dmsTabBarMore(!this.props.dmsTabBarMore());
			this.props.activeItem(item);
			const moreIsOpened = ko.unwrap(this.props.dmsTabBarMore);
			if (moreIsOpened) {
				this.props.dmsTabBarItems().find(el => {
					return el.IsActive;
				});
			}
			return;
		}

		this.props.dmsTabBarMore(false);

		if (item.Url !== this.cfg.getCurrentLocation() && !item.Items.length) {
			console.log(item, item.Url);
			onBeforeUnloadHandler.redirectWithoutAlert(item.Url);
			this._smartMenu.checker(false);
			this.props.activeItem(item);

			if (menuKey.startsWith('Dms') && !this.isPwaMode) {
				_.delay(() => scrollTo('.nfd-page-container'), 100);
			}
		}
	};

	_handleTemplaters = (): void => {
		this._tasks.forEach(({payload}) => this._handleNewSingleTemplate(payload));
	};

	_handleNewSingleTemplate (data: any): void {
		const item = findMenuItemByKey(this.props.items.peek(), data.key);

		if (!item) {
			return;
		}

		let htmlView = '';

		if (_.isFunction(data.value) && !ko.isObservable(data.value)) {
			htmlView = data.value(item);
		} else {
			htmlView = data.value;
		}

		item.htmlLink(htmlView);
	}

	_fetchItems (fetcher: () => Promise<*>) {
		this._isFetching(true);

		fetcher()
			.then(() => this._isFetching(false))
			.then(this._handleTemplaters);
	}


	_sayScreenAdapterAboutChanges = (): void => { //see template.html in looking for binding screenAdapter
		this._isListRendered(true);
	};

	_selectOption (key: string): $Values<params> {
		return _.get(this._options, key);
	}

	requestItems (): void {
		this._fetchItems(this._selectOption('onItemsFetch'));
	}

	setState (data: any): void { // hasn't known full-type yet
		const {type, payload} = data;

		switch (type) {
			case menuTypes.MENU_ITEMS_FETCHED: {
				MenuModel._menuJSable.fromJS(payload);
				return;
			}
			case menuTypes.MENU_CONFIGURATION_CHANGED: {
				this._cfg(payload);
				return;
			}
			default: {
				this._tasks.push(data);

				if (!this._isFetching.peek()) {
					this._handleNewSingleTemplate(payload);
				}
			}
		}
	}
}



const toObject = (items: MenuItem[], found: MenuItem) =>
	({items: items || [], found: found || null});

const spreadFieldsForNextChain = (menuItem: MenuItem) => toObject((menuItem || {}).Items, menuItem);

const findWantedMenuItemByKey = (items: MenuItem[], key: string) =>
	spreadFieldsForNextChain(items.find((item: MenuItem) => item.Key() === _.trim(key)));


function findMenuItemByKey (menuItems: MenuItem[], menuKey: string): MenuItem {
	const menuItemKey = (menuKey || '').split('.'); // Dms.DmsNotifications -> [Dms, DmsNotifications]

	return menuItemKey.reduce((prev, currentKey) =>
		findWantedMenuItemByKey(prev.items, currentKey), toObject([...menuItems])).found;
}

